import React from 'react';
import PropTypes from 'prop-types';
import {TweenMax} from 'gsap/all';
import MorphSVGPlugin from  './../gsap-bonus/MorphSVGPlugin'



class Map extends React.Component {   

    constructor(props){
        super(props);
        this.setInternals = this.setInternals.bind(this);
        this.reset = this.reset.bind(this);
        this.state = {
            path : 'null',
            
        }
        this.node=null;
    }
    componentWillMount(){ }
    
    componentDidMount(){ 
        this.setInternals(this.props)
    }
    componentWillReceiveProps(newProps){
        this.setInternals(newProps)
    
    }
    setInternals(props){
        
        if(!props.selected || !this.node) return null;
        TweenMax.to(this.node, 0.3, {morphSVG : props.selected.path} )
        this.setState({path : props.selected.path})

        
    }
    reset(){
        this.setState({
            path : null
        })
        TweenMax.to(this.node, 0.3, {morphSVG : "M275,275 276,276Z"} )
    }
  
    render(){


        return (
            <div className="Map">
                <svg viewBox="0 0 557.04 546.4">
                    <path ref={(node)=>this.node=node} d="M275,275 276,276Z" fill="#F6B600"/>
                </svg>
                <style jsx>{`
                    
                    .Map {
                        position: relative;
                        padding-top:98.02513465%!important;
                    }   
                    svg {
                        position: absolute;
                        top:0px;
                        left:0px;
                        right:0px;
                        bottom:0px;
                    } 
                `}</style>
            </div>
        )
    }
}

Map.propTypes = {
    
}

export default Map;